import {useTranslation} from "react-i18next";

import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";

import DialogActions from "@mui/material/DialogActions";
import MDButton from "../../../materialDashboard/components/MDButton";
import MDLoadingButton from "../../../components/MDLoadingButton";
import {useUserMutation} from "../query";
import Stack from "@mui/material/Stack";
import Icon from "@mui/material/Icon";
import MDBox from "../../../materialDashboard/components/MDBox";
import {useCurrentUser} from "../../../auth/CurrentUserProvider";


const EditRoleDialog = ({user, close}) => {
    const {t} = useTranslation(["user", "enums"]);
    const userMutation = useUserMutation(user.id);

    const [role, setRole] = React.useState(user.role);

    const handleSave = async () => {
        await userMutation.mutateAsync({role: role});
        close();
    }

    const handleChangeRole = (role) => () => {
        setRole(role);
    }

    const {currentUser} = useCurrentUser();
    const currentUserRole = currentUser?.data?.role ?? null;
    const allowedRoles = currentUserRole === "ADMIN" ? ["ADMIN", "WG_ADMIN", "WG_USER"] : ["WG_USER", "WG_ADMIN"];

    return <Dialog onClose={close} open={true} maxWidth="lg" fullWidth>
        <DialogTitle>{t('editRole.title')}</DialogTitle>
        <DialogContent>
            <MDBox paddingBottom={4}>
                {t('editRole.description')}
            </MDBox>

            <Stack spacing={1} direction="row" justifyContent="space-evenly">
                {
                    allowedRoles.includes("WG_USER") &&
                    <MDButton variant={role === "WG_USER" ? "contained" : "outlined"}
                              color="info"
                              sx={{width: "8.25rem", height: "6.125rem"}}
                              disableRipple
                              onClick={handleChangeRole("WG_USER")}>
                        <Stack direction="column" alignItems="center">
                            <Icon>person</Icon>
                            {t('enums:role.WG_USER')}
                        </Stack>
                    </MDButton>
                }
                {
                    allowedRoles.includes("WG_ADMIN") &&
                    <MDButton variant={role === "WG_ADMIN" ? "contained" : "outlined"}
                              color="info"
                              sx={{width: "8.25rem", height: "6.125rem"}}
                              disableRipple
                              onClick={handleChangeRole("WG_ADMIN")}>
                        <Stack direction="column" alignItems="center">
                            <Icon>person</Icon>
                            {t('enums:role.WG_ADMIN')}
                        </Stack>
                    </MDButton>
                }
                {
                    allowedRoles.includes("ADMIN") && <MDButton variant={role === "ADMIN" ? "contained" : "outlined"}
                                                                color="info"
                                                                sx={{width: "8.25rem", height: "6.125rem"}}
                                                                disableRipple
                                                                onClick={handleChangeRole("ADMIN")}>
                        <Stack direction="column" alignItems="center">
                            <Icon>person</Icon>
                            {t('enums:role.ADMIN')}
                        </Stack>
                    </MDButton>
                }
            </Stack>
        </DialogContent>

        <DialogActions>
            <MDButton onClick={close} color="info" variant="outlined">
                {t('editRole.cancel')}
            </MDButton>
            <MDLoadingButton onClick={handleSave} color="info" variant="gradient" loading={userMutation.isLoading}
                             disabled={user.role === role}>
                {t('editRole.submit')}
            </MDLoadingButton>
        </DialogActions>
    </Dialog>
}

export default EditRoleDialog;